import { Mic, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { useGlobalAgent } from "@/contexts/GlobalAgentContext";
import { motion, AnimatePresence } from "motion/react";
import { FAB_INSET, FAB_SIZE, Z } from "@/lib/overlay-constants";

export function VoiceAgentFAB() {
  const { openAgent, state, minimizeAgent } = useGlobalAgent();
  const isActive = state.isOpen && !state.isMinimized;

  return (
    <button
      onClick={isActive ? minimizeAgent : openAgent}
      aria-label={isActive ? "Fermer l'assistant" : "Assistant vocal"}
      className={cn(
        "fixed flex items-center justify-center rounded-full bg-background transition-colors",
        isActive
          ? "text-foreground border-transparent"
          : "text-muted-foreground border border-border hover:bg-muted",
      )}
      style={{
        right: FAB_INSET,
        bottom: `calc(${FAB_INSET}px + env(safe-area-inset-bottom, 0px))`,
        width: FAB_SIZE,
        height: FAB_SIZE,
        zIndex: isActive ? Z.fabActive : Z.fabIdle,
      }}
    >
      <AnimatePresence mode="wait" initial={false}>
        {isActive ? (
          <motion.div
            key="close"
            initial={{ rotate: -90, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            exit={{ rotate: 90, opacity: 0 }}
            transition={{ duration: 0.15 }}
          >
            <X className="w-6 h-6" />
          </motion.div>
        ) : (
          <motion.div
            key="mic"
            initial={{ rotate: 90, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            exit={{ rotate: -90, opacity: 0 }}
            transition={{ duration: 0.15 }}
          >
            <Mic className="w-6 h-6" />
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
